module.exports = __webpack_public_path__ + "974b8c20925e1b02febe656623c73dfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/collosal_battles-420.jpg
// module id = 214
// module chunks = 0